import React from "react";
import { Link } from "react-router-dom";

import { useRedirectToCertification } from '../../utils/redirect';

import StaticLayout from "./StaticLayout";
import "./landing-page.scss";

export default function QualificationsPage() {
  useRedirectToCertification("qualifications");
  return (
    <StaticLayout>
      <div className="section horizontal-page-title qualification-static">
        <div className="container">
          <div className="content-row">
            <div className="content-row-contents">
              <div className="badge badge-title text-primary-2" />
              <h1 className="heading-3">Qualifications</h1>
              <p style={{ color: "white" }}>
                Anyone can say they’re Black-owned, but here they can prove it.
              </p>
            </div>
            <div className="justify-center page-title-text">
              <div className="content-row-contents" />
            </div>
          </div>
        </div>
        <div className="decoration-container">
          <img
            src="/landing-page/images/grid-dark.svg"
            alt=""
            className="decoration-grid"
          />
          <div
            data-w-id="35f9b2b5-6f2e-bcc0-b419-0ce254d19861"
            className="decoration-circle bg-primary-3"
          />
        </div>
      </div>

      <div>
        <div className="container">
          <div className="section-title" style={{ marginBottom: 0 }}>
            <div className="badge badge-title text-white" />
            <h2 className="medium-heading-3">What it takes to get certified</h2>
            <p>
              If your company is headquartered in the United States and is majority
              owned and operated by a Black person or persons, you qualify for
              this certification. We simply request that you provide the proper
              documentation based on your business structure to help us verify
              your qualifications and ensure the accuracy of your statements.{" "}
              <span className="download-cta">
                [
                <Link to="/documents/guide.pdf" target="_blank">
                  Click here
                </Link>
                ] to download copy of our Qualification Guide that outlines
                specific documentation you will need to certify your business.
              </span>
            </p>
            <p>
              Our certification has three major components. Each section
              requires you to share certain information for us to better
              understand and ultimately verify your business as Black-Owned.
              Check out the necessary documents below.
            </p>

            <div
              className="block-section container cert-container align-items-center mt-30"
              style={{ marginTop: 60 }}
            >
              <div className="block-section-60 font-weight-bold hero">
                <div className="text-large qualification-static">
                  <div>
                    <h3 className="heading-1">Basic Business Information</h3>

                    <div className="para-1">
                      <p>
                        <span className="text-1">1. Business Name</span> Your
                        legally registered business name and/or the name your
                        business is currently operating under.
                      </p>

                      <p>
                        <span className="text-1">
                          2. Federal Employer Identification Number
                        </span>{" "}
                        If you have more than two employees, we request you
                        provide a valid EIN. If you need more information on
                        EINs learn more{" "}
                        <a href="https://www.irs.gov/businesses/small-businesses-self-employed/apply-for-an-employer-identification-number-ein-online">
                          here
                        </a>
                        .
                      </p>

                      <p>
                        <span className="text-1">3. Address</span> The location
                        where your business is headquartered and is documented
                        in corporate filings and records.
                      </p>
                      <p>
                        <span className="text-1">4. Business Phone Number</span>
                      </p>
                      <p>
                        <span className="text-1">5. Website URL</span> You are
                        not required to have a business website, however it is
                        preferred.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="block-section container cert-container align-items-center mt-30"
              style={{ marginTop: 60 }}
            >
              <div className="block-section-60 font-weight-bold hero">
                <div className="text-large qualification-static">
                  <div>
                    <h3 className="heading-1">Proof of Ownership</h3>

                    <div className="para-1">
                      <p>
                        We request these documents to prove that your company
                        has at least 51% ownership by Black individuals and
                        shareholders. Not all documents may apply to your
                        business based on your business’s structure (ex: LLC,
                        Corporation, Partnership, or Sole Proprietorship)
                      </p>

                      <p>
                        <span className="text-1">
                          1. Name of Registered Owners{" "}
                        </span>{" "}
                        The name of the owner(s) whose name is authorized on
                        corporate filings and state records.
                      </p>

                      <p>
                        <span className="text-1">2. Resume of Owner(s) </span>{" "}
                        Necessary if a business is a Corporation.
                      </p>
                      <p>
                        <span className="text-1">
                          3. Proof of Contribution{" "}
                        </span>{" "}
                        Documented proof of contributions used to acquire
                        ownership showing that the owner paid for the value of
                        his/her interest in the business or in some way invested
                        personal funds into the business. Acceptable proof
                        includes both sides of cancelled checks or receipts for
                        costs associated with starting/acquiring your business
                        (ie, fees for State Corporation registration, legal
                        fees, insurance, equipment/supplies, business licenses,
                        marketing, and training). If unavailable and the firm is
                        more than five (5) years old, a signed and notarized
                        statement describing the personal investment may be
                        acceptable.
                      </p>
                      <p>
                        <span className="text-1">
                          4. Copies of Stock Certificates{" "}
                        </span>{" "}
                        (both sides) or proof of stock purchase or equity
                        agreement by Black owner(s) and/or currents stock
                        transfer ledger.
                      </p>
                      <p>
                        <span className="text-1">5. Form 1120 Schedule K </span>{" "}
                        Necessary for businesses filed as an S-Corporation.
                      </p>
                      <p>
                        <span className="text-1">6. Form 1065 Schedule C </span>{" "}
                        Necessary for businesses filed as a Partnership.
                      </p>
                      <p>
                        <span className="text-1">7. Form 1120 Schedule G </span>{" "}
                        Necessary for businesses filed as a C-Corporation.
                      </p>
                      <p>
                        <span className="text-1">7. Form 1065 K-1s </span> (for
                        each owner), Form 1120 Schedule G, OR Form 1065 Schedule
                        K-1 (for each owner) - Necessary for businesses filed as
                        a Single or Multi-Member Limited Liability Company
                        (LLC).
                      </p>
                      <p>
                        <span className="text-1">8. Form 1040 Schedule </span>{" "}
                        Necessary for business filed as a Sole Proprietorship.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="block-section-40" style={{ margin: "auto" }}>
                <img
                  style={{ maxWidth: 350 }}
                  src="/assets/images/qualifications/rect1.png"
                  alt=""
                />
              </div>
            </div>

            <div className="block-section container cert-container align-items-center mt-30">
              <div className="block-section-60 font-weight-bold hero">
                <div className="text-large qualification-static">
                  <div>
                    <h3 className="heading-1">
                      Proof of Control And Operation
                    </h3>

                    <div className="para-1">
                      <p>
                        We require documents to ensure that your business is run
                        by the Black business owners applying. To help us verify
                        this, we may ask you to provide relevant business
                        documents that show you exercise control over your
                        business’s day-to-day operations.
                      </p>

                      <p>
                        You may choose{" "}
                        <span className="text-1">
                          any one of the following documents.
                        </span>{" "}
                        We may require additional information if all information
                        is not clearly present.
                      </p>

                      <p>
                        <span className="text-1">
                          1. Business License or Professional License:
                        </span>{" "}
                        Copies of professional licenses and permits, including
                        all licenses and permits held by the business, its
                        owner(s), and officer(s) of the business in the areas of
                        work in which the business is seeking certification.
                      </p>

                      <p>
                        <span className="text-1">
                          2. Certificate of Incorporation/Organization:
                        </span>{" "}
                        A legal document/license relating to the formation of a
                        company or corporation.
                      </p>

                      <p>
                        <span className="text-1">
                          3. Articles of Incorporation/Organization:
                        </span>{" "}
                        Charter that establishes the existence of a corporation
                        generally filed with the Secretary of State.
                      </p>

                      <p>
                        <span className="text-1">
                          4. Minutes of First Board Meeting Establishing Current
                          Ownership:
                        </span>{" "}
                        Corporations must provide a copy of the first documented
                        meeting or formal quorum minutes as signed and dated by
                        the President and Acting Secretary. Proprietary
                        information may be redacted.
                      </p>

                      <p>
                        <span className="text-1">
                          5. Minutes from the most recent meeting of
                          shareholders:
                        </span>{" "}
                        Document must include owner/registrant's
                        name.Corporations must provide a copy of the most recent
                        meeting or formal quorum minutes as signed and dated by
                        the President and Acting Secretary. Proprietary
                        information may be redacted.
                      </p>

                      <p>
                        <span className="text-1">
                          6. Minutes from the most recent meeting of the Board:
                        </span>{" "}
                        Detailed statements and annotations of discussions and
                        decisions held by an organization during the most recent
                        meeting. Proprietary information may be redacted.
                      </p>
                      <p>
                        <span className="text-1">7. Corporate Bylaws:</span>{" "}
                        Necessary for businesses filed as a Corporation.
                      </p>
                      <p>
                        <span className="text-1">8. Operating Agreement:</span>{" "}
                        An operating agreement is a key document used by limited
                        liability companies (LLCs) to outline the business'
                        financial and functional decisions including rules,
                        regulations and provisions.
                      </p>
                      <p>
                        <span className="text-1">
                          9. Partnership Agreements:
                        </span>{" "}
                        Fully executed copy of the official contract between two
                        or more individuals who manage and operate the business
                        together in order to make a profit.
                      </p>
                      <p>
                        <span className="text-1">
                          10. Proof of Capital Investment by Black Partners:
                        </span>{" "}
                        An official document indicating the method by which the
                        owner(s) obtained ownership interest such as cancelled
                        checks, opening bank statement, proof of stock purchase,
                        written statement by owner, list of contributed
                        equipment/expertise, etc. Necessary for businesses filed
                        as a Partnership.
                      </p>
                      <p>
                        <span className="text-1">
                          11. Limited Partnership Agreements:
                        </span>{" "}
                        A fully executed partnership agreement that outlines the
                        general partner's authority, as well as the limited
                        partner's rights, roles, and responsibilities.
                      </p>
                      <p>
                        <span className="text-1">
                          12. Profit Sharing Agreements:
                        </span>{" "}
                        An executed copy of the official contract outlining the
                        terms of the profit sharing arrangement required for
                        Partnerships.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="block-section-40" style={{ margin: "auto" }}>
                <img
                  style={{ maxWidth: 350 }}
                  src="/assets/images/qualifications/rect2.png"
                  alt=""
                />
              </div>
            </div>

            <div className="block-section container cert-container align-items-center mt-30">
              <div className="block-section-60 font-weight-bold hero">
                <div className="text-large qualification-static">
                  <div>
                    <h3 className="heading-1">Proof of Identity</h3>
                    <div className="para-1">
                      <p>
                        <span className="text-1">
                          * U.S. Passport, State Issued Driver’s License{" "}
                        </span>
                      </p>
                      <p>
                        <span className="text-1">* Identification Card </span>
                      </p>
                      <p>
                        <span className="text-1">* Green Card </span>
                      </p>
                    </div>

                    <div className="para-1">
                      <p>
                        We recognize that there are many ways to verify your
                        Blackness. Though this list is not exhaustive, if
                        readily available or applicable, please provide us with
                        any (as many) of the below affinity documents in support
                        of your application that attest to your ethnicity. This
                        step is NOT mandatory, but can be used to increase
                        confidence and expedite the process of certification.”
                      </p>
                      <p>
                        <span className="text-1">
                          1. Ancestry or Lineage Tree of Family Members
                        </span>
                      </p>

                      <p>
                        <span className="text-1">
                          2. Letter of Identity Verification from a local Black
                          chamber president
                        </span>
                      </p>
                      <p>
                        <span className="text-1">
                          3. Membership in a Black Chamber of Commerce
                        </span>
                      </p>
                      <p>
                        <span className="text-1">
                          4. Supplementary Ethnicity Documents including
                          Membership of African American Social Groups or Trade
                          Associations, (Panhellenic Sororities/Fraternities,
                          Diploma from a Historically Black College or
                          University (HBCU).{" "}
                        </span>
                      </p>
                      <p>
                        <span className="text-1">
                          5. Previous certification by a third party certifying
                          agency or federal government agency as a African
                          American or MBE business where race is clearly stated
                          in the documents provided by certifier
                        </span>
                      </p>
                      <p>
                        <span className="text-1">
                          6. Three Referrals from current ByBlack Certified
                          Businesses
                        </span>
                      </p>
                      <p>
                        <span className="text-1">
                          7. Birth certificate of family members that explicitly
                          denote the race of the person
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="block-section-40" style={{ margin: "auto" }}>
                <img
                  style={{ maxWidth: 350 }}
                  src="/assets/images/qualifications/rect3.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="section-title">
            <div className="badge badge-title text-white" />
            <h3 className="medium-heading-2 ">Virtual Site Visit</h3>
            <div className="">
              <p className="h5-small-1" style={{ paddingTop: "20px" }}>
                As a best practice, on-site visits play a vital part in ensuring
                the integrity of the certification offered by leading business
                supplier diversity certification agencies. Unlike other
                application experiences, ByBlack Platform provides a fully
                virtual experience that affords you the ability to answer our
                strategically aligned set of questions from the safety of your
                office and on your own time. In this step we will ask you about
                information regarding your business ownership, operation, and
                control that is complementary to the information presented in
                the certification application. In this post pandemic climate,
                our virtual site visit is the new innovative way to provide a
                safe and secure interview experience.
              </p>
            </div>
            <h3 className="medium-heading-2 ">
              Our Process for Certifying You
            </h3>
            <div className="">
              <p className="h5-small-1" style={{ paddingTop: "20px" }}>
                Once your application is submitted, our team gets to work. Each
                application is reviewed by two specialists who each read the
                provided documents to carefully assess a business owner’s
                credibility for certification. If each reviewer agrees on the
                accuracy of the information, they can usually certify a business
                within 30 to 45 business days. However, based on the documents
                provided and the breadth of information included for a
                submission, this timeline can vary. If business owners submit
                incomplete documents or inaccurate information, we will reach
                out to request additional documents from the business owner and
                assess the supplemental data that was shared. These follow ups
                can add extra time for our reviewers so please ensure you have
                submitted all pertinent documents for our team.
              </p>
            </div>
            <h3 className="medium-heading-2" style={{ paddingTop: "50px" }}>
              Maintaining your Black business Certification
            </h3>
            <div>
              {/* <p className="h5-small-1" style={{ paddingTop: "20px" }}>
                There is no limit to the length of time a business can
                participate and continue to be certified as long as it continues
                to qualify as Black-owned. Certified businesses must notify
                ByBlack if their business is involved in a merger or acquisition
                that drops black ownership below 51%.
              </p> */}
              <p className="h5-small-1">
                USBC may visit certified businesses unannounced and conduct
                program examinations to verify the accuracy of any certification
                made or information provided as part of the ByBlack Business
                Certification application process.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="section-title">
        <div className="container">
          <div className="cta-container">
            <h3 className="medium-heading-2">Have more questions?</h3>
            <p className="h5-small-1">
              You can reach out to our team to learn more here.
            </p>
            <div className="cta-action-container">
              <a
                href="mailto:certification@byblack.us"
                className="button w-button"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
      </div>
    </StaticLayout>
  );
}
